const resources = {
    showMore: 'Afficher plus',
    rougeBadge: 'EXCLUSIVITÉ ROUGE'
};

export default function getResource(label) {
    return resources[label];
}
